import { render } from "./vmemberplusbuy.vue?vue&type=template&id=24febede&scoped=true"
import script from "./vmemberplusbuy.vue?vue&type=script&lang=js"
export * from "./vmemberplusbuy.vue?vue&type=script&lang=js"

import "./vmemberplusbuy.vue?vue&type=style&index=0&id=24febede&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24febede"]])

export default __exports__